import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * One page width for the whole app. Before this the container + <h1> was
 * copy-pasted across 11 pages at five different max-widths, so navigating
 * between routes shifted the content column sideways.
 */
export function PageContainer({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('mx-auto w-full max-w-6xl px-4 py-6 md:px-6 md:py-8', className)}>{children}</div>
}

interface PageHeaderProps {
  title: string
  description?: ReactNode
  /** Right-aligned controls: primary action, export buttons, filters toggle. */
  actions?: ReactNode
  className?: string
}

export function PageHeader({ title, description, actions, className }: PageHeaderProps) {
  return (
    <div className={cn('mb-6 flex flex-wrap items-start justify-between gap-3', className)}>
      <div className="min-w-0 space-y-1">
        {/* A real <h1> — the app previously had pages whose only heading was a div. */}
        <h1 className="truncate text-h1 font-semibold tracking-tight">{title}</h1>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  )
}
